import { Grid } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { FC, ReactNode } from "react";


interface EmptyLayoutProps {
    children?: ReactNode | ReactNode[];
}

const usePageStyles = makeStyles(() =>
    createStyles({
        app: { flexWrap: "nowrap" },
        page: {
            flexGrow: 1,
            overflow: "hidden",
        },
    }),
);

const EmptyLayout: FC<EmptyLayoutProps> = ({ children }) => {
    const pageClasses = usePageStyles();

    return (
        <Grid container className={clsx("app", pageClasses.app)}>
            <Grid item className={pageClasses.page}>
                <main>
                    {children}
                </main>
            </Grid>
        </Grid>
    );
};

export default EmptyLayout;
